module.exports = __webpack_public_path__ + "static/media/pumpkins.6d7c8a7b.jpg";